import type { HTMLAttributes } from 'react';

import { cn } from 'src/utils/classNamesHelper';

export const Sheet = ({
  className = '',
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'rounded-2 flex flex-col gap-16 bg-paper-1 p-24 shadow-sheet ls:p-32',
      className
    )}
    {...rest}
  >
    {children}
  </div>
);
